import React from "react";
import { View, Text, TextInput, StyleSheet } from "react-native";

const TextAreaField = ({ label, value, onChangeText, placeholder, helperText, error }) => {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.label}>{label}</Text>
      <TextInput
        style={[styles.textArea, error ? styles.errorBorder : null]}
        placeholder={placeholder}
        placeholderTextColor="#94a3b8"
        multiline
        value={value}
        onChangeText={onChangeText}
        textAlignVertical="top"
      />
      <Text style={[styles.helper, error ? styles.errorText : null]}>
        {error || helperText || "\u00a0"}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: "100%",
    marginBottom: 18,
  },
  label: {
    fontWeight: "700",
    color: "#1f2937",
    fontSize: 14,
    marginBottom: 8,
  },
  textArea: {
    minHeight: 140,
    borderRadius: 16,
    padding: 16,
    backgroundColor: "#f8fafc",
    borderWidth: 1,
    borderColor: "#d1d5db",
    color: "#111827",
    fontSize: 15,
  },
  helper: {
    marginTop: 8,
    fontSize: 12,
    color: "#6b7280",
    lineHeight: 18,
  },
  errorBorder: {
    borderColor: "#f97316",
  },
  errorText: {
    color: "#b91c1c",
  },
});

export default React.memo(TextAreaField);
